"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalFooter = void 0;
var _react = _interopRequireDefault(require("react"));
var _Footer = require("../styled/Footer");
/**
 * ModalFooter is a component intended to be composed inside a Modal.
 *
 * It is a simple default implementation of a footer, only rendering the given
 * children (ideally buttons) flush-right
 */
const ModalFooter = _ref => {
  let {
    /**
     * Content to render flush right. Generally set of ModalFooterButton components.
     */
    children,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Footer.StyledModalFooter, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_Footer.StyledFooterButtons, null, children));
};
exports.ModalFooter = ModalFooter;
//# sourceMappingURL=ModalFooter.js.map